import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { ThemeConstellation, Divider, Spacer, Flex } from '@zillow/constellation';
import { useEffect, useState } from 'react';
import Header from './Header';
import CalculatorForm from './CalculatorForm';
import { ENV } from './constants';
import { initCalculatorConfigs } from './configs';
import { CalculatorContext } from './useCalculatorContext';
import { SecondaryCta } from './outputs';

const AffordabilityCalculator = ({ env, debug }) => {
    const [outputs, updateOutputs] = useState(null);

    useEffect(() => {
        initCalculatorConfigs(env);
    }, [env]);

    useEffect(() => {
        if (debug) {
            // eslint-disable-next-line no-console
            outputs && console.info(JSON.stringify(outputs, null, 2));
        }
    }, [debug, outputs]);

    return (
        <ThemeProvider theme={ThemeConstellation}>
            <CalculatorContext.Provider value={{ outputs, updateOutputs }}>
                <Flex display="flex" flexDirection="column">
                    <Header />
                    <Divider marginY="md" />
                    <CalculatorForm />
                </Flex>
                {outputs?.outcome && (
                    <>
                        <Spacer marginTop="xl" />
                        <SecondaryCta outputs={outputs} />
                    </>
                )}
            </CalculatorContext.Provider>
        </ThemeProvider>
    );
};

AffordabilityCalculator.propTypes = {
    env: PropTypes.oneOf(Object.values(ENV)).isRequired,
    debug: PropTypes.bool,
};

AffordabilityCalculator.defaultProps = {
    debug: false,
};

AffordabilityCalculator.ENV = ENV;

export default AffordabilityCalculator;
